import React from "react";

interface SectionHeaderProps {
  title: string;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({ title }) => {
  return (
    <div className="relative mb-2 overflow-hidden border-b border-zinc-200/60 bg-zinc-50/50 px-4 py-4 backdrop-blur-sm dark:border-zinc-800/80 dark:bg-zinc-900/30">
      <h3 className="relative flex items-center gap-2 text-sm font-bold text-zinc-800 dark:text-zinc-200">
        <span className="bg-accent h-1.5 w-1.5 rounded-full" />
        {title}
      </h3>
    </div>
  );
};

export default SectionHeader;
